<template>
   <div>
    <el-row :gutter="48">
        <el-col :lg="6" :md="48">
            <el-select filterable v-model="form.yearRest" placeholder="请选择年度法定休息日" clearable @change="handleChangeYear('compensatoryLeave')">
              <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
            </el-select>
            <table v-if="form.yearRest" v-loading="loading" width="100px">
              <thead>
                <tr>
                  <th>月份</th>
                  <th>法定节假休息日</th>
                  <th>合计</th>
                </tr>
              </thead>
              <tbody>
                <tr class="tr"  :class="{'active':active===item}"  v-for="item in 12" :key="item" @click="handleClick(form.yearRest,item)">
                  <td width="50px">{{ item }}月</td>
                  <td>
                    <div class="dis">
                      <div v-for="(data,index) in day[item - 1]">{{filterDay(data,index,day[item - 1].length)}}</div>
                    </div>
                  </td>
                  <td width="50px">{{ day[item - 1].length}}</td>
                </tr>
                <tr>
                  <td colSpan="2">合计</td>
                  <td width="50px">{{ totalDay(day) }}</td>
                </tr>
              </tbody>
            </table>
        </el-col>
        <el-col :lg="6" :md="24">
            <el-select filterable v-model="form.compensatoryLeave" placeholder="请选择年度法定调休日" clearable @change="handleChangeYear('yearRest')">
              <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
            </el-select>
            <table v-if="form.compensatoryLeave" v-loading="loading">
              <thead>
                <tr>
                  <th>月份</th>
                  <th>法定节假调休日</th>
                  <th>合计</th>
                </tr>
              </thead>
              <tbody>
                <tr class="tr" :class="{'active':active===item}" v-for="item in 12" :key="item" @click="handleClick(form.compensatoryLeave,item)">
                  <td width="50px">{{ item}}月</td>                  
                  <td>
                    <div class="dis">
                      <div v-for="(data,index) in day[item - 1]">{{filterDay(data,index,day[item - 1].length)}}</div>
                    </div>
                  </td>
                  <td width="50px">{{ day[item - 1].length}}</td>
                </tr>
                <tr>
                  <td colSpan="2">合计</td>
                  <td width="50px">{{ totalDay(day) }}</td>
                </tr>
              </tbody>
            </table>
        </el-col>
        <el-col :lg="12" :md="24">
          <el-calendar v-model="value">
            <template
              slot="dateCell"
              slot-scope="{date, data}">
              <p @click=" handleChange( data.day )">
                {{ data.day.split('-')[2] }} {{ dayList.indexOf(data.day) !== -1  ? '✔️' : ''}}
              </p>
            </template>
          </el-calendar>
        </el-col>
      </el-row>
   </div>
</template>
<script>
import dayjs from 'dayjs'
import { Attendance } from '@/api/attendance'
export default {
  data() {
    return {
      form: {
        yearRest: '',
        compensatoryLeave:''
      },
      yearList: [],
      dayList: [],
      day:[],
      value: dayjs().format('YYYY-MM'),
      type: '',
      loading: false,
      active:''
    }
  },
  created() {
    this.initDate()
  },
  methods: {
    initDate() {
      const year = new Date().getFullYear()
      for (let index = 2023; index < year + 10; index++) {
        this.yearList.push(index)
      }
    },
    getList(year) {
      this.value = dayjs(this.value).format('YYYY-MM-DD')
      const m = this.value.split('-')[1]
      this.value = year+ '-' + m
      this.loading = true
      const data = {
        calendarType:this.type,
        year
      }
      this.day = [[],[],[],[],[],[],[],[],[],[],[],[]]
      Attendance.getList(this, data).then(res => {
        res.data.forEach(item => {
          this.day[item.month-1] = item.datas.map(data => data.time)
        })
        this.dayList = this.day[m-1]
        this.loading = false
      })
    },
    handleChange(val) {
      if( !this.form.compensatoryLeave && !this.form.yearRest) return
      const index = this.dayList.indexOf(val)
      const flag = (new Date(val).getDay() === 0 || new Date(val).getDay() === 6) && this.type === 'LEGAL_REST_DAY'
      if (index === -1) {
        const arr = val.split('-')
        const data = {
          calendarConfigDto: {
            calendarType: flag ? 'LEGAL_REST_DAY_WEEK' : this.type,
            day: arr[2],
            month: arr[1],
            year: arr[0],
            time:val
          }
        }
        Attendance.createDay(this, data).then(res => {
           this.dayList.push(val)
        })
      } else {
        Attendance.deleteDay(this, {
          calendarType:flag ? 'LEGAL_REST_DAY_WEEK' : this.type,
          time:val
        }).then(res => {
          this.dayList.splice(index,1)
        })
      }
    },
    handleClick(year, item) {
      this.active = item
      this.value = year + '-' + item
      this.dayList = this.day[item - 1]
    },
    handleChangeYear(value) {
      this.form[value] = ''
      if (value === 'yearRest') {
        this.type = 'STATUTORY_DAY_REST'
        this.getList(this.form.compensatoryLeave)
      } else {
        this.type = 'LEGAL_REST_DAY'
        this.getList(this.form.yearRest)
      }
    },
    filterDay(data,index,count) {

      return index === count-1 ?  data.split('-')[2] : data.split('-')[2] +','
    },
    totalDay(arr) {
      let total = 0
      arr.forEach(item => {
        total += item.length
      })
      return total
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-select{
  width: 100%;
}
table{
  margin: 30px 0;
  width: 100%;
  height: 600px;
  border: 1px solid #e9e4e4;
  border-collapse: collapse;
  th{
    height: 40px;
  }
  td,
  th,
  tr{
    border: 1px solid #e5e4e4;
    text-align: center;
    text-overflow:ellipsis;
    cursor:pointer;
  }
  .active,
  .tr:hover{
    color:#fff;
    background-color:#a9d3ef;
  }
  td{
    word-break: break-all;
    word-wrap:break-word;
  }
}
.dis{
  display:flex;
  flex-wrap:wrap;
}
::v-deep.el-calendar__button-group{
  display: none;
} 
::v-deep.el-calendar__header{
  border-bottom:none;
} 

::v-deep.el-calendar__title{
     font-weight: 700;
      font-size: 25px;
  }
  ::v-deep.current{
    border-radius: 50%;
    border: none;
    text-align: center;
    line-height: 40px;
  }
  ::v-deep.prev{
    pointer-events:none
  }
  ::v-deep.prev>.el-calendar-day,
  ::v-deep.next{
    display: none;
  } 
  ::v-deep.el-calendar-table td{
    border: none;
  }
  ::v-deep.el-calendar-table tr:first-child td {
    border-top: none;
}
  ::v-deep.el-calendar-table tr td:first-child {
    border-left: none;
}
::v-deep.el-calendar-table td.is-selected{
  background-color: #fff;
}
</style>
  
  